<template>
	<div class="w5-field text-search">
			<span class="al" :class="{ 'animated': fieldAnimated, 'focused': Focused || !Empty, 'unfocused': !Focused && Empty }">{{ Title | ftc }}<span class="required-field"> *</span></span>
			<input
				ref="inputComponent"
				type="text"
				:placeholder="'mails/templates' | ftc"
				v-model="currentValue"
				@input="searchText"
				@focus="setFocus(true)"
				@blur="setFocus(false)"
				@click="init"
				class="input-text"
			/>
			<div ref="listItems" class="items-wrapper scrollable">
				<template v-show="foundItems.length > 0 && !isRequest">
					<div v-for="item in foundItems" class="found-item scrollable" @click="selectText(item.name)">{{ item.name }}</div>
				</template>
				<div v-show="isRequest" class="found-item">{{ 'text/find_templates' | ftc }}</div>
			</div>			
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'textSearch',
	//=========================================================================
	// свойства, задаются только родителем
	//=========================================================================
	props: ['Field'],
	//=========================================================================
	// локальные свойства
	//=========================================================================
	data() {
		return {
			isRequest: false,
			fieldAnimated: false,
			Focused: false,
			currentValue: '',
			timer: null,
			foundItems: [],
			$listItems: null
		}
	},
	computed: {
		Empty() {
			return this.currentValue === undefined || this.currentValue === null || this.currentValue === ''
		},
		Title() {
			return this.Field.title
		},
		Url() {
			return this.Field.url
		}
	},
	//=========================================================================
	// событие: компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		EventBus.$on('w5-click-on-modal', this.clickHandler)
		document.addEventListener('keydown', this.keyDownHandler)

		if (this.$listItems && this.$listItems.length) this.$listItems.remove()
		// найдем список
		this.$listItems = $(this.$refs.listItems)
		if (this.$listItems.length)
		{
			// переносим
			this.$listItems.detach().appendTo($('body'))
		}
		else this.$listItems = null
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-click-on-modal', this.clickHandler)
		document.removeEventListener('keydown', this.keyDownHandler)

		if (this.$listItems && this.$listItems.length) this.$listItems.remove()
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// инициализация
		//---------------------------------------------------------------------
		init() {
			this.currentValue = ''
			this.foundItems = []
			this.isRequest = false
		},
		//---------------------------------------------------------------------
		// установка значения Focused
		//---------------------------------------------------------------------
		setFocus(value) {
			// если это фокус
			if (value)
			{
				this.fieldAnimated = true
			}
			this.$set(this, 'Focused', value)
			this.recountBlock()
			this.$forceUpdate()
		},
		//---------------------------------------------------------------------
		// начало поиска текстов
		//---------------------------------------------------------------------
		searchTextStart() {
			if (this.timer) clearTimeout(this.timer)
			this.timer = setTimeout(() => { this.searchText() }, 300)
		},
		//---------------------------------------------------------------------
		// поиск текстов
		//---------------------------------------------------------------------
		searchText() {
			if (this.currentValue === undefined || this.currentValue === null || this.currentValue === '')
			{
				this.init()
				return
			}

			this.isRequest = true
			this.foundItems = []

			this.$http.get(this.APIServerUrl + this.Url + this.currentValue, {
				// определим колбак "before"
				before(request) {
					// если есть предыдущий запрос - прервем его
					if (this.previousRequest) this.previousRequest.abort()
					// установим в предыдущий запрос - текущий
					this.previousRequest = request
				}
			}).then(
				// успешный ответ
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['result'] && Array.isArray(_dt['result']) && _dt['result'].length)
					{
						this.foundItems = _dt['result'].slice()
					}
				}
			).catch(() => {
				this.isRequest = false
			}).finally(() => {
				this.isRequest = false
			})
		},
		//---------------------------------------------------------------------
		// выбрали какой то текст
		//---------------------------------------------------------------------
		selectText(text) {
			this.init()
			this.$emit('textSelected', text)
		},
		//---------------------------------------------------------------------
		// обработчик нажатия клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			if (e.keyCode === 27 && this.foundItems.length)
			{
				this.init()
				e.preventDefault()
				e.stopPropagation()
				e.stopImmediatePropagation()
			}
		},
		//---------------------------------------------------------------------
		// обработчик кликов
		//---------------------------------------------------------------------
		clickHandler() {
			this.init()
		},
		//---------------------------------------------------------------------
		// расчет размеров и позиционирование блока со списком
		//---------------------------------------------------------------------
		recountBlock() {
			if (!this.$listItems || !this.$listItems.length) return

			let $component = $(this.$el)
			if (!$component || !$component.length) return

			// расчитаем координаты блока
			let _elHeight = $component.height()
			let _elOffset = $component.offset()
			let _elWidth = $component.width()
			if (_elWidth <= 0) _elWidth = '100%'

			let _css = {
				top: _elOffset.top + _elHeight + 10,
				left: _elOffset.left,
				maxWidth: _elWidth,
				zIndex: 9998
			}
			if (this.$store.state.windowWidth <= 767)
				_css.width = _elWidth

			this.$listItems.css(_css)
		}

		//---------------------------------------------------------------------
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style scoped>
	.text-search {
		padding-right: 0;
	}
	.items-wrapper {
		position: absolute;
		width: 100%;
		margin-top: -2px;
		background-color: #efefef;
		border-radius: 0 0 4px 4px;
		overflow: auto;
		max-height: 200px;
		z-index: 9998;
	}
	.found-item {
		font-size: 85%;
		color: black;
		padding: 10px;
		border-top: 1px solid #ccc;
		max-height: 79px;
		overflow: hidden;
		text-overflow: ellipsis;
		cursor: pointer;
		user-select: none;
	}
	.found-item:hover {
		color: white;
		background-color: #3ba3ff;
    	border-color: #3ba3ff;
	}
</style>



// WEBPACK FOOTER //
// text.vue?4d35acfb